import { TableContext } from "@stenajs-webui/grid";
import { StoreState } from "@/redux/RootReducer";
import { BulkEditRatesTableColumn } from "../config/BulkEditRatesTableConfig";
import { bulkEditRatesActions } from "../redux/reducer";
import { getBulkEditRatesCalculateActualForPriceRowQueryVariables } from "./FetchActualChangeForSinglePriceRow";
import { fetchCalculateNewPriceForRows } from "@/features/product-and-price/queries/FetchCalculateNewPricesForRows";
import { ActualChangeForPriceRowQueryVariables } from "@/gql/graphql";
import { refetchStatBoxesWithBulkEditRatesChanges } from "../components/stat-boxes/thunks/RefetchStatBoxesWithBulkEditRatesChanges";
import { isEqual } from "lodash";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";

export const fetchBulkEditRatesActualChangeForAllPriceRows = async (
  dispatch: ThunkDispatch<StoreState, undefined, AnyAction>,
  tableContext: TableContext<BulkEditRatesTableColumn>,
  getState: () => StoreState
) => {
  const tableState = getState().bulkEditRatesState;
  const selectedPricesIds =
    getState().bulkEditRatesTableState.standardTable.selectedIds.selectedIds;

  await Promise.all(
    selectedPricesIds.map((routeAgreementPriceId) => {
      const routeAgreementId =
        tableState.edited[routeAgreementPriceId]?.routeAgreement.id;

      const variables: ActualChangeForPriceRowQueryVariables =
        getBulkEditRatesCalculateActualForPriceRowQueryVariables(
          getState(),
          routeAgreementId ?? "",
          routeAgreementPriceId
        );
      return fetchCalculateNewPriceForRows(variables).then((response) => {
        const actual =
          response.data?.productPrice.actualPriceChange
            .calculateActualPriceChange ?? null;

        const latestVariables: ActualChangeForPriceRowQueryVariables =
          getBulkEditRatesCalculateActualForPriceRowQueryVariables(
            getState(),
            routeAgreementId ?? "",
            routeAgreementPriceId
          );

        const userHasNotChangedInputs = isEqual(latestVariables, variables);

        if (userHasNotChangedInputs) {
          dispatch(
            bulkEditRatesActions.setValue({
              id: routeAgreementPriceId,
              actual,
            })
          );
        }
      });
    })
  );
  dispatch(refetchStatBoxesWithBulkEditRatesChanges());
  dispatch(bulkEditRatesActions.setBulkUpdateRatesLoading(false));
  tableContext.dispatch(tableContext.actions.clearSelection());
};
